import React from "react";
import Lottie from "lottie-react";
import Header2 from "../Header2/Header2";
import Footer2 from "../Footer2/Footer2";
import "./Comunicacion.css";

// Animaciones
import communicationAnim from "../../Assets/Animations/chat.json";
import messageAnim from "../../Assets/Animations/chat.json";
import bellAnim from "../../Assets/Animations/notification.json";
import familyAnim from "../../Assets/Animations/Audience Reach (1).json";
import teacherAnim from "../../Assets/Animations/Classroom.json";
import institutionAnim from "../../Assets/Animations/Establish.json";

function Comunicacion() {
  return (
    <>
      <Header2 />
      <section className="comunicacion-section">

        {/* Fondo decorativo */}
        <div className="comunicacion-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>

        {/* HERO COMUNICACIÓN */}
        <div className="comunicacion-hero">
          <div className="comunicacion-hero-content">

            {/* Icono animado con contenedor especial */}
            <div className="comunicacion-icon-container">
              <div className="icon-wrapper">
                <Lottie
                  animationData={communicationAnim}
                  loop
                  className="comunicacion-main-anim"
                />
                <div className="icon-glow"></div>
              </div>
              <div className="icon-particles">
                <span className="particle p1"></span>
                <span className="particle p2"></span>
                <span className="particle p3"></span>
              </div>
            </div>

            {/* Contenido textual */}
            <div className="comunicacion-hero-text">
              <span className="comunicacion-badge">
                <i className='bx bx-message-rounded-detail'></i>
                Comunicación institucional
              </span>

              <h1 className="comunicacion-title">
                Todo lo que la institución comunica,
                <span className="title-highlight"> en un solo canal</span>
              </h1>

              <p className="comunicacion-subtitle">
                Mensajes claros, notificaciones en tiempo real y comunicación
                ordenada entre institución, familias, docentes y alumnos.
              </p>

              {/* Stats de comunicación */}
              <div className="comunicacion-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <Lottie animationData={messageAnim} loop />
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">+95%</span>
                    <span className="stat-label">Mensajes entregados</span>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <Lottie animationData={bellAnim} loop />
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">-70%</span>
                    <span className="stat-label">Ruido comunicacional</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* FLUJO DE COMUNICACIÓN MEJORADO */}
        <div className="comunicacion-flow-section">
          <div className="section-header">
            <h2>
              Un ecosistema de comunicación
              <span> conectado y eficiente</span>
            </h2>
            <p>
              Cada mensaje llega al destinatario correcto, en el momento adecuado,
              sin pérdidas ni malentendidos.
            </p>
          </div>

          <div className="comunicacion-flow">

            {/* Institución */}
            <div className="flow-card flow-institution">
              <div className="flow-icon">
                <Lottie animationData={institutionAnim} loop />
              </div>
              <div className="flow-content">
                <div className="flow-header">
                  <h3>Institución</h3>
                  {/* <span className="flow-badge">Emisor principal</span> */}
                </div>
                <p>
                  Emite comunicados oficiales, avisos, recordatorios
                  y mensajes importantes desde un único lugar.
                </p>
                <ul className="flow-features">
                  <li><i className='bx bx-check'></i> Comunicados organizados</li>
                  <li><i className='bx bx-check'></i> Calendario institucional</li>
                  <li><i className='bx bx-check'></i> Notificaciones masivas</li>
                </ul>
              </div>
            </div>

            {/* Conector 1 */}
            <div className="flow-connector">
              <div className="connector-line"></div>
              <div className="connector-arrow">
                <i className='bx bx-right-arrow-alt'></i>
              </div>
            </div>

            {/* Familias */}
            <div className="flow-card flow-family">
              <div className="flow-icon">
                <Lottie animationData={familyAnim} loop />
              </div>
              <div className="flow-content">
                <div className="flow-header">
                  <h3>Familias</h3>
                  {/* <span className="flow-badge">Receptor esencial</span> */}
                </div>
                <p>
                  Reciben información clara, organizada y confiable,
                  sin depender de grupos externos o mensajes perdidos.
                </p>
                <ul className="flow-features">
                  <li><i className='bx bx-check'></i> Notificaciones push</li>
                  <li><i className='bx bx-check'></i> Historial completo</li>
                  <li><i className='bx bx-check'></i> Confirmación de lectura</li>
                </ul>
              </div>
            </div>

            {/* Conector 2 */}
            <div className="flow-connector">
              <div className="connector-line"></div>
              <div className="connector-arrow">
                <i className='bx bx-right-arrow-alt'></i>
              </div>
            </div>

            {/* Docentes y Alumnos */}
            <div className="flow-card flow-teachers">
              <div className="flow-icon">
                <Lottie animationData={teacherAnim} loop />
              </div>
              <div className="flow-content">
                <div className="flow-header">
                  <h3>Docentes/alumnos</h3>
                  {/* <span className="flow-badge">Comunidad educativa</span> */}
                </div>
                <p>
                  Acceden a notificaciones relevantes y mensajes
                  vinculados a la vida institucional.
                </p>
                <ul className="flow-features">
                  <li><i className='bx bx-check'></i> Comunicación interna</li>
                  <li><i className='bx bx-check'></i> Alertas académicas</li>
                  <li><i className='bx bx-check'></i> Espacios colaborativos</li>
                </ul>
              </div>
            </div>

          </div>
        </div>

        {/* BENEFICIOS DE COMUNICACIÓN */}
        <div className="comunicacion-benefits">
          <div className="benefits-header">
            <h2>
              Más que mensajes,
              <span> tranquilidad institucional</span>
            </h2>
            <p>
              Reducí la carga administrativa y concentrate en lo que realmente importa.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className='bx bx-time-five'></i>
              </div>
              <h4>Ahorro de tiempo</h4>
              <p>
                Eliminá horas de coordinación y seguimiento de mensajes.
              </p>
              {/* <span className="benefit-tag">+40% eficiencia</span> */}
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">
                <i className='bx bx-shield-alt'></i>
              </div>
              <h4>Seguridad y trazabilidad</h4>
              <p>
                Cada comunicación queda registrada y es totalmente trazable.
              </p>
              {/* <span className="benefit-tag">Comunicación auditada</span> */}
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">
                <i className='bx bx-group'></i>
              </div>
              <h4>Comunidad conectada</h4>
              <p>
                Todos los actores institucionales alineados y sincronizados.
              </p>
              {/* <span className="benefit-tag">Conexión 360°</span> */}
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">
                <i className='bx bx-trending-up'></i>
              </div>
              <h4>Mejora continua</h4>
              <p>
                Datos y métricas para optimizar la comunicación institucional.
              </p>
              {/* <span className="benefit-tag">Insights valiosos</span> */}
            </div>
          </div>
        </div>

        {/* CIERRE EMOCIONAL */}
        <div className="comunicacion-closing">
          <div className="closing-container">
            <div className="closing-icon">
              <i className='bx bx-check-circle'></i>
            </div>
            <h3 className="closing-title">
              Menos desorden. Menos confusión.
              <span> Más tranquilidad institucional.</span>
            </h3>
            <p className="closing-text">
              Tresaedu transforma la comunicación escolar en una experiencia
              organizada, segura y centrada en lo educativo.
            </p>

            {/* CTA de comunicación */}
            <div className="comunicacion-cta">
              <a
                href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                <i className='bx bx-message-detail'></i>
                <span>Optimizar la comunicación de mi institución</span>
              </a>
              <p className="cta-subtext">
                Asesoramiento personalizado sin costo
              </p>
            </div>
          </div>
        </div>

      </section>
      <Footer2 />
    </>
  );
}

export default Comunicacion;